interface DatedReview {
  date?: string | null;
}

function reviewTime(review: DatedReview): number {
  if (!review.date) return 0;
  const t = new Date(review.date).getTime();
  return Number.isNaN(t) ? 0 : t;
}

export function sortReviewsByRecent<T extends DatedReview>(reviews: readonly T[]): T[] {
  return [...reviews].sort((a, b) => reviewTime(b) - reviewTime(a));
}

export function abbreviateName(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length <= 1) return parts[0] || name;
  return `${parts[0]} ${parts[parts.length - 1][0]}.`;
}

export function parseRating(rating: string | number | null | undefined): number {
  const n = typeof rating === 'number' ? rating : parseInt(String(rating ?? ''), 10);
  if (!Number.isFinite(n) || n <= 0) return 5;
  return Math.min(5, Math.round(n));
}

export function ReviewStars({ rating }: { rating: string | number | null | undefined }) {
  const value = parseRating(rating);
  return (
    <div className="flex items-center gap-0.5" aria-label={`${value} out of 5 stars`}>
      {Array.from({ length: 5 }, (_, i) => (
        <svg
          key={i}
          className={`w-4 h-4 ${i < value ? 'text-amber-400' : 'text-[var(--vibe-color-border)]'}`}
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}
